<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'shed')"

  >

    <template #addDataForm>
      <shed-add-update></shed-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">

        <template v-if="cell.field.key === 'shed'">
            <template v-if="get(cell.item, 'id')">
                <shed-cell :data="cell.item"></shed-cell>
            </template>
            <template v-else>
                {{cell.item}}
            </template>
        </template>
        <template v-else-if="cell.field.key === 'platform'">
            <template v-if="get(cell.value, 'id')">
                <platform-cell :data="cell.value"></platform-cell>
            </template>

        </template>

        <template v-else-if="cell.field.key === 'user'">
            <template v-if="get(cell.value, 'id')">
                <user-cell :user="cell.value"></user-cell>
            </template>

        </template>
    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../shedStoreModule'
  import useShed from '../useShed'

  import ShedAddUpdate from '../components/ShedAddUpdate'

  import get from 'lodash.get'

  import UserCell from "@/views/apps/user/components/UserCell";
  import ShedCell from "@/views/apps/railway_structure/shed/components/ShedCell";
  import PlatformCell from "@/views/apps/railway_structure/platform/components/PlatformCell";

  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
        PlatformCell,
        UserCell,
      ShedCell,
      ElementsLayout,
      ShedAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = useShed();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
